import styled from 'styled-components';

import { fontSize, FontSizes, fontWeight, FontWeights, minWidth, units } from '@calm-web/design-system';

export const Container = styled.div`
	svg {
		${fontSize(FontSizes.lg)}
		${fontWeight(FontWeights.Light)}
    height: ${units(6.5)};
		width: 100%;
		${minWidth('desktop')} {
			${fontSize(FontSizes['3xl'])}
		}
	}
`;
